import { createContext } from 'react';

import { TPrototypeReportPasswordShortInfo } from '@app-velocity/av-api-v2';

export type ScenarioViewerContextType = {
  scenario: TPrototypeReportPasswordShortInfo;
  shareToken: string;
};

export const ScenarioViewerContext = createContext<ScenarioViewerContextType>({
  scenario: {},
  shareToken: '',
});
